module.exports = __webpack_public_path__ + "static/market-square.dfc0e75a.jpg";